import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import cx from 'classnames';
import React from 'react';
import styles from './icon.module.scss';
import { BASE_ICON_SPRITE_PATH, IconColor, IconSize, } from './icon-constants';
import { appendSVGSprite, getIconPathFromIconID } from './icon-utils';
export { IconColor, IconID, IconSize } from './icon-constants';
export { appendSVGSprite };
export const setupIconSprites = async () => {
    const ICON_SPRITE_PARAM = 'iconSprite';
    await appendSVGSprite(BASE_ICON_SPRITE_PATH, 'base-icon-sprite');
    await appendSVGSprite(getQueryParamsAndQueryString().queryParams[ICON_SPRITE_PARAM], 'custom-sprite-override', true);
};
setupIconSprites();
export const Icon = ({ id, size = IconSize.MEDIUM, color = IconColor.BLACK, strokeColor, className = '', ...restProps }) => {
    const iconClass = cx(className, styles.iconStyle, styles[`${size}`], styles[`${color}`], strokeColor && styles[`stroke-${strokeColor}`]);
    return (React.createElement("svg", { className: iconClass, ...restProps, "data-radiant-v2": true },
        React.createElement("use", { xlinkHref: getIconPathFromIconID(id) })));
};
//# sourceMappingURL=icon.js.map